import Model from "@/app/models/Concerns/Model";
import {AxiosResponse} from "axios";
import Client from "@/app/Http/Client";

export default class Division extends Model {
    public name!: string;
    public stationsCount?: number;

    getTable(): string {
        return "divisions";
    }
}